import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  const dropdownAjaxProjects = ($selector) => {
    if ($selector.length === 0) {
      return;
    }

    const plugins = [];
    const preExistingOptions = [];
    const selectedValues = [];

    if ($selector[0].dataset.options) {
      try {
        const dataOptions = JSON.parse($selector[0].dataset.options.replace(/&quot;/g, '"'));
        dataOptions.forEach((option) => {
          preExistingOptions.push(option);
          const isModal = $selector[0].closest('.modal');
          if ((isModal && option.id) || option.selected) {
            selectedValues.push(option.id.toString());
          }
        });
      } catch (e) {
        console.error('Error getting data-options:', e);
      }
    }

    const selectizeInstance = $selector.selectize({
      plugins,
      maxOptions: null,
      persist: true,
      placeholder: 'Select a project...',
      valueField: 'id',
      labelField: 'name',
      searchField: ['name', 'email'],
      preload: false,
      options: preExistingOptions,
      items: selectedValues,
      load(query, callback) {
        loadProjects({ query, page: 1, append: false, callback, selectizedInstance: this });
      },
      render: {
        item(item, _escape) {
          return `<div class="selectize-input__item">${item.name}</div>`;
        },
        option(item, _escape) {
          return `<div class="selectize-dropdown-content__project">${item.name}</div>`;
        },
      },
      onFocus() {
        if (!this.hasLoadedOnce) {
          this.hasLoadedOnce = true;
          loadProjects({
            query: '',
            page: 1,
            append: false,
            selectizedInstance: this,
            onComplete: (result) => {
              this.refreshOptions(true);
              this.open();
            },
          });
        } else {
          this.refreshOptions(true);
          this.open();
        }
      },
      onDropdownOpen($dropdown) {
        let currentPage = 1;
        let isLoadingMore = false;
        let hasMorePages = true;
        const dropdownContent = $dropdown[0].querySelector('.selectize-dropdown-content');

        if (dropdownContent && !dropdownContent.dataset.scroll) {
          dropdownContent.dataset.scroll = 'true';

          dropdownContent.onscroll = async () => {
            const nearBottom =
              dropdownContent.scrollTop + dropdownContent.clientHeight >=
              dropdownContent.scrollHeight - 50;
            if (nearBottom && !isLoadingMore && hasMorePages) {
              isLoadingMore = true;
              currentPage += 1;
              await loadProjects({
                query: this.lastQuery || '',
                page: currentPage,
                append: true,
                selectizedInstance: this,
                onComplete: (result) => {
                  isLoadingMore = false;
                  if (!result || result.length === 0) {
                    hasMorePages = false;
                  }
                },
              });
            }
          };
        }

        if (!this.hasLoadedOnce) {
          this.hasLoadedOnce = true;
          loadProjects({
            query: '',
            page: 1,
            append: false,
            selectizedInstance: this,
            onComplete: (result) => {
              hasMorePages = result && result.length > 0;
            },
          });
        }
      },
      onChange(value, $item) {
        this.$input.trigger('selectizeProject:change', [value, $item]);
      },
    });

    // Needed so we can check if selectize is initialized
    $selector[0].dataset.initialized = true;

    if (selectedValues.length > 0) {
      setTimeout(() => {
        const selectizeControl = $selector[0].selectize;
        if (selectizeControl) {
          selectedValues.forEach((value) => {
            selectizeControl.addItem(value, true); // true = silent add
          });
        }
      }, 0);
    }

    return selectizeInstance;
  };

  const loadProjects = ({
    query = '',
    page = 1,
    append = false,
    callback,
    selectizedInstance,
    onComplete,
  } = {}) => {
    const params = new URLSearchParams({ search: query, page });

    fetch(`/dropdowns/projects?${params.toString()}`)
      .then((res) => res.json())
      .then((data) => {
        selectizedInstance.settings._pagination = data.pagination;

        data.projects.forEach((item) => {
          selectizedInstance.addOption(item);
        });
        selectizedInstance.refreshOptions(false);

        if (callback) {
          callback(data.projects);
        }
        if (onComplete) {
          onComplete(data.projects);
        }
      })
      .catch(() => {
        if (callback) {
          callback();
        }
        if (onComplete) {
          onComplete();
        }
      });
  };

  const initDropdownAjaxProjects = () => {
    const $dropdowns = $('select.selectize-control--project-dropdown-ajax').filter(function () {
      return this.dataset.initialized !== 'true';
    });

    if ($dropdowns.length > 0) {
      dropdownAjaxProjects($dropdowns);
    }
  };

  $(document).on('turbo:before-stream-render', (event) => {
    const stream = event.detail.newStream;
    if (
      stream.getAttribute('action') !== 'update' ||
      stream.getAttribute('target') !== 'project-selection-content'
    ) {
      return;
    }

    const originalRender = event.detail.render;
    event.detail.render = function (streamElement) {
      originalRender(streamElement);
      initDropdownAjaxProjects();
    };
  });

  $(document).on('modal:open', function (_, { elm }) {
    initDropdownAjaxProjects();
  });

  $(document).ready(function () {
    initDropdownAjaxProjects();
  });
});
